import { Schema } from '@togglecorp/ravl';

const superviseSchema: Schema[] = [
    {
        doc: {
            name: 'superviseDailyLog',
            description: 'Supervise Daily log schema',
        },
        fields: {
            userDetails: { type: 'miniUser', required: true },
        },
        extends: 'dailyLog',
    },
    {
        doc: {
            name: 'superviseDailyLogs',
            description: 'Supervise Daily logs schema',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.superviseDailyLog', required: true },
        },
    },
    {
        doc: {
            name: 'superviseOffsiteMeeting',
            description: 'Supervise offsite meeting schema',
        },
        fields: {
            supervisorName: { type: 'string' },
            userDetails: { type: 'miniUser', required: true },
        },
        extends: 'offsiteMeeting',
    },
    {
        doc: {
            name: 'superviseOffsiteMeetings',
            description: 'Supervise offsite meetings schema',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.superviseOffsiteMeeting', required: true },
        },
    },
    {
        doc: {
            name: 'superviseTravel',
            description: 'Supervise travel schema',
        },
        fields: {
            userDetails: { type: 'miniUser', required: true },
            totalTravelDays: { type: 'uint', required: true },
            supervisorDetails: { type: 'miniUser' },
        },
        extends: 'travel',
    },
    {
        doc: {
            name: 'superviseTravels',
            description: 'Supervise travels schema',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.superviseTravel', required: true },
        },
    },
    {
        doc: {
            name: 'superviseLeave',
            description: 'Supervise leave schema',
        },
        fields: {
            userDetails: { type: 'miniUser', required: true },
        },
        extends: 'leave',
    },
    {
        doc: {
            name: 'superviseLeaves',
            description: 'Supervise leave schema',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.superviseLeave', required: true },
        },
    },
];
export default superviseSchema;
